import { AppLocale, Translate, translate } from '@/shared/i18n';
import { BoosterType } from '@/shared/types/Billing';

import { AllBoosters } from './types';

const englishT: Translate = (key, variables) => translate('en', key, variables);

export const formatCurrency = (cents: number, currency = 'USD', locale: AppLocale = 'en') =>
  new Intl.NumberFormat(locale, { currency, style: 'currency' }).format(cents / 100);

export const formatBoosterExpirationDate = (date: string, locale: AppLocale = 'en'): string =>
  new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(new Date(date));

export const formatBoosterPrice = (
  allBoosters: AllBoosters | null,
  boosterType: BoosterType,
  quantity = 1,
  locale: AppLocale = 'en',
): string => {
  const booster = allBoosters?.[boosterType];
  const currency = booster?.prices[0]?.currency ?? 'USD';
  const totalCents = (booster?.price ?? 0) * quantity;

  return formatCurrency(totalCents, currency, locale);
};

export const formatBoosterSeatsText = (
  seatsCount: number,
  allBoosters: AllBoosters | null,
  locale: AppLocale = 'en',
  t: Translate = englishT,
): string => {
  const price = formatBoosterPrice(allBoosters, BoosterType.TeamspaceSeat, seatsCount, locale);

  return t(seatsCount === 1 ? 'boosters.seats.addOneForMonth' : 'boosters.seats.addManyForMonth', {
    count: seatsCount,
    price,
  });
};
